import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const PLANS = [{
  id: 'biblia',
  emoji: '📖',
  name: 'LA BIBLIA DEL TRUCO',
  badge: null,
  subtitle: '6 tomos + 3 bonos estratégicos',
  oldPrice: '$39.990',
  price: '$19.990',
  checkoutUrl: 'https://trucocheckout.ebookditales.com/cart/44984384159823:1',
  ctaText: '✅ SÍ, QUIERO LA BIBLIA DEL TRUCO →',
  includesTitle: 'LA BIBLIA DEL TRUCO INCLUYE:',
  features: ['6 tomos completos paso a paso', 'Sistema completo de cero a nivel torneo', 'El Método del Ajedrez Criollo', '3 bonos estratégicos completos', 'Diccionario de 100 versos listos', 'Cheat Sheet de señas para pareja', '20 jugadas tácticas listas para aplicar']
}, {
  id: 'pack',
  emoji: '🏆',
  name: 'PACK COMPLETO',
  badge: '⭐ MÁS ELEGIDO',
  subtitle: '6 tomos + 3 bonos + 3 extras exclusivos',
  oldPrice: '$59.990',
  price: '$24.990',
  checkoutUrl: 'https://trucocheckout.ebookditales.com/cart/44984400805967:1',
  ctaText: '✅ SÍ, QUIERO EL PACK COMPLETO →',
  includesTitle: 'EL PACK COMPLETO INCLUYE TODO LO ANTERIOR +:',
  features: ['El Diccionario del Verso Prohibido — 130 frases y rimas listas para manejar el clima de la mesa. Incluye tono y momento exacto para cada situación.', 'El Playbook de Jugadas Sucias (Legales) — 20 tácticas maestras: "La trampa del pie", el "Envido de sacrificio" y el "Retruco fantasma". Jugadas 100% legales de profesionales.', 'Cheat Sheet de Señas e Inteligencia en Pareja — Guía visual rápida con señas esenciales y avanzadas + lenguaje de acciones para comunicarte sin hablar.']
}];
export function PricingSection() {
  const [selected, setSelected] = useState('biblia');
  const plan = PLANS.find(p => p.id === selected)!;
  return <section id="pricing" className="py-24 bg-gradient-to-b from-truco-dark to-black relative border-t border-truco-gold/20 scroll-mt-10" data-id="element-103">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,168,83,0.15),transparent_50%)] pointer-events-none" data-id="element-104" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-105">
        <div className="text-center mb-10" data-id="element-106">
          <CountdownTimer data-id="element-107" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-truco-surface border-2 border-truco-gold rounded-3xl p-6 md:p-12 shadow-[0_0_50px_rgba(212,168,83,0.15)] max-w-2xl mx-auto" data-id="element-108">
          <div className="text-center mb-8" data-id="element-109">
            <h2 className="text-3xl font-heading font-bold text-truco-cream mb-2" data-id="element-110">
              Elegí tu{' '}
              <span className="text-truco-gold" data-id="element-111">Biblia del Truco:</span>
            </h2>
            <p className="text-truco-creamMuted" data-id="element-112">
              Todas las opciones incluyen los 3 bonos estratégicos
            </p>
          </div>

          {/* Plan selector cards */}
          <div className="space-y-3 mb-8" data-id="element-113">
            {PLANS.map(p => {
            const isSelected = selected === p.id;
            return <button key={p.id} onClick={() => setSelected(p.id)} className={`w-full text-left rounded-xl p-4 md:p-5 border-2 transition-all duration-200 flex items-center gap-4 ${isSelected ? 'border-truco-gold bg-truco-gold/10 shadow-[0_0_20px_rgba(212,168,83,0.15)]' : 'border-truco-gold/20 bg-truco-dark/50 hover:border-truco-gold/40'}`} data-id="element-114">
                  {/* Radio circle */}
                  <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-all ${isSelected ? 'border-truco-gold' : 'border-truco-creamMuted/40'}`} data-id="element-115">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-truco-gold" data-id="element-116" />}
                  </div>

                  {/* Plan info */}
                  <div className="flex-1 min-w-0" data-id="element-117">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-118">
                      <span className="text-lg" data-id="element-119">{p.emoji}</span>
                      <span className="font-heading font-black text-truco-cream text-base md:text-lg" data-id="element-120">
                        {p.name}
                      </span>
                      {p.badge && <span className="bg-truco-gold text-truco-dark text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-121">
                          {p.badge}
                        </span>}
                    </div>
                    <p className="text-xs sm:text-sm text-truco-creamMuted mt-0.5" data-id="element-122">
                      {p.subtitle}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0" data-id="element-123">
                    <p className="text-xs text-truco-creamMuted/60 line-through" data-id="element-124">
                      {p.oldPrice}
                    </p>
                    <p className={`text-2xl md:text-3xl font-heading font-black ${isSelected ? 'text-truco-gold' : 'text-truco-cream'}`} data-id="element-125">
                      {p.price}
                    </p>
                  </div>
                </button>;
          })}
          </div>

          {/* Tags */}
          <div className="flex justify-center gap-3 mb-6 text-xs font-bold text-truco-cream uppercase tracking-wider flex-wrap" data-id="element-126">
            <span className="bg-truco-dark px-3 py-1.5 rounded-full border border-truco-gold/20" data-id="element-127">
              Pago único
            </span>
            <span className="bg-truco-dark px-3 py-1.5 rounded-full border border-truco-gold/20" data-id="element-128">
              Acceso inmediato
            </span>
            <span className="bg-truco-dark px-3 py-1.5 rounded-full border border-truco-gold/20" data-id="element-129">
              Descarga ilimitada
            </span>
          </div>

          {/* CTA */}
          <a href={plan.checkoutUrl} className="block w-full bg-gradient-to-r from-truco-gold to-[#e6c070] text-truco-dark font-heading font-black text-lg md:text-2xl px-8 py-5 rounded-xl shadow-[0_0_30px_rgba(212,168,83,0.4)] hover:shadow-[0_0_50px_rgba(212,168,83,0.6)] transition-all transform hover:scale-[1.02] text-center mb-8" data-id="element-130">
            {plan.ctaText}
          </a>

          {/* Features */}
          <div className="bg-truco-dark rounded-xl p-6 border border-truco-gold/10" data-id="element-131">
            <h3 className="font-heading font-bold text-truco-cream mb-4 text-center text-sm uppercase tracking-wider" data-id="element-132">
              {plan.includesTitle}
            </h3>
            <ul className="space-y-3" data-id="element-133">
              {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-134">
                  <CheckCircle2Icon className="w-5 h-5 text-truco-gold shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-sm text-truco-creamMuted" data-id="element-136">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="text-center text-xs text-truco-creamMuted/60 mt-4 italic" data-id="element-137">
            Podés sumar la otra opción cuando quieras
          </p>

          <div className="mt-6 flex items-center justify-center gap-2 text-truco-creamMuted text-sm" data-id="element-138">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-139" />
            <span data-id="element-140">Compra 100% segura y garantizada</span>
          </div>
        </motion.div>
      </div>
    </section>;
}